import { render, staticRenderFns } from "./text-field.component.vue?vue&type=template&id=d2546bc6&scoped=true&"
import script from "./text-field.component.vue?vue&type=script&lang=ts&"
export * from "./text-field.component.vue?vue&type=script&lang=ts&"
import style0 from "./text-field.component.vue?vue&type=style&index=0&id=d2546bc6&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2546bc6",
  null
  
)

export default component.exports